import { IconButton, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';

type FilterProps = {
  isFilterOpen: boolean;
  handleFilterClick: () => void;
  isFilterActive: boolean;
};
export const VyFilter: React.FC<FilterProps> = ({ handleFilterClick, isFilterOpen }) => {
  return (
    <IconButton
      sx={{
        color: 'black',
        backgroundColor: '#0D1B270F',
        '&:hover': {
          backgroundColor: '#E0E0E0',
        },
        padding: '5px 10px !important',
        borderRadius: '4px',
        border: isFilterOpen ? '1px solid #0D1B273B' : undefined,
        position: 'relative',
      }}
      onClick={handleFilterClick}
    >
      <VyIcon
        icon="Filter"
        style={{
          transform: 'scale(0.8)',
        }}
      />
      <Typography variant="body2">Filters</Typography>
    </IconButton>
  );
};
